export default __webpack_public_path__ + "static/media/headphone.141c7fa4.webp";